import React from "react"
import {
  AutoLoadUsers,
  IUserFuncProps,
} from "../../../../../../components/templates/auto-load-users"
import { JSONRPCClientBuilder } from "../../../../../../request/JSONRPCClientBuilder"
import { ChannelRPC } from "../../../../../../rpcs/dist/ChannelRPC"
import { User } from "../../../../../../rpcs/dist/UserRPC"
import { IChannelContainerProps } from "../../../../container"

interface IProps {
  channelId: number
  followers: User[] | null
  actions: IChannelContainerProps["actions"]
}

export const List = (props: IProps) => {
  const update = (users: User[]) => {
    props.actions.appendChannelFollowers(users)
  }

  const getUserFunc = ({ page }: IUserFuncProps) => {
    const channelRPC = JSONRPCClientBuilder.build(ChannelRPC)
    return channelRPC.listFollowers({
      channelId: props.channelId,
      page,
    })
  }

  const unmount = () => {
    props.actions.unmountChannelFollowers()
  }

  return (
    <AutoLoadUsers
      users={props.followers}
      update={update}
      reset={unmount}
      getUserFunc={getUserFunc}
    />
  )
}
